import type { PaletteOptions } from '@mui/material';

const primary: string = '#2577A0';
const secondary: string = '#EF5455';

const lightPalette: PaletteOptions = {
  mode: 'light',
  primary: {
    main: primary,
    light: '#5487AC',
    dark: '#1E668A',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: secondary,
    light: '#FAE6E5',
    contrastText: '#FFFFFF',
  },
  gradient: {
    light: '#389CC3',
    main: '#2577A0',
    dark: '#125680',
    contrastText: '#FFFFFF',
  },
  text: {
    primary: '#1A1A1A',
    secondary: '#646464',
    disabled: '#9E9E9E',
  },
  background: {
    default: '#F5F6F9',
    paper: '#FFFFFF',
  },
  success: {
    light: '#EDF7ED',
    main: '#57BA56',
    dark: '#193C19',
    contrastText: '#FFFFFF',
    50: '#e7f5e6',
    100: '#c5e6c3',
    200: '#9fd59d',
    300: '#77c674',
    400: '#58ba56',
    500: '#36ae36',
    600: '#2c9f2d',
    700: '#1e8d22',
    800: '#0d7c16',
    900: '#005d02',
  },
  info: {
    light: '#DBEFF9',
    main: '#19B5CD',
    dark: '#84A3C0',
    contrastText: '#FFFFFF',
    50: '#e0f6f9',
    100: '#b1e9f0',
    200: '#80dae7',
    300: '#4fcbdc',
    400: '#2ec0d4',
    500: '#19b5cd',
    600: '#17a5ba',
    700: '#1491a1',
    800: '#127d89',
    // This colour is info.dark in Figma
    900: '#09434C', // '#0e5a5e',
  },
  action: {
    hover: '#F5F6F9',
  },
  warning: {
    light: '#FFF7DF',
    main: '#FFC107',
    dark: '#FD7608',
    contrastText: '#FFFFFF',
    50: '#fff8e1',
    100: '#ffecb3',
    200: '#ffe082',
    300: '#ffd54f',
    400: '#ffca28',
    500: '#ffc107',
    600: '#ffb300',
    700: '#ffa000',
    800: '#ff8f00',
    900: '#ff6f00',
  },
  error: {
    light: '#FAE6E5',
    main: '#DC3545',
    dark: '#480D12',
    contrastText: '#FFFFFF',
    50: '#ffebee',
    100: '#fecdd3',
    200: '#ef9b9c',
    300: '#e57476',
    400: '#ef5454',
    500: '#f4433b',
    600: '#e53a3a',
    700: '#d33033',
    800: '#c62a2c',
    900: '#b71e21',
  },
  purple: {
    main: '#721D6C',
    contrastText: '#FFFFFF',
  },
  teal: {
    main: '#00BFB2',
    contrastText: '#FFFFFF',
  },
  orange: {
    main: '#FD9C4D',
  },
  pink: {
    main: '#E87EA1',
  },
  common: {
    black: '#1A1A1A',
    white: '#FFFFFF',
    accentLightblue: '#EDF5FB',
    accentWhite: '#FDFDFD',
  },
  divider: '#E8E9F0',
  grey: {
    '50': '#F9F9F9',
    '100': '#F2F2F2',
    '200': '#E8E8E8',
    '300': '#D9D9D9',
    '400': '#B4B4B4',
    '500': '#949494',
    '600': '#6C6C6C',
    '700': '#595959',
    '800': '#3A3A3A',
    '900': '#1A1A1A',
    A100: '#FAFAFA',
    A200: '#E8E9F0',
    A400: '#D9D9D9',
    A700: '#999999',
  },
  tonalOffset: {
    dark: 0.2,
    light: 0.2,
  },
};

export { lightPalette };
